import { Box, Button, Flex, Grid, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { sendTrackingEvent } from '../../../utils/gtm';

const UnlockingOpportunities = ({ data }: any) => {
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	return (
		<Grid
			flexDirection={['column', 'column', 'column', 'row', 'row', 'row']}
			bg="#F6EDE7"
			gridTemplateColumns={{ base: '1fr', lg: domainConfig?.uiConfig?.orgBannerImage ? '1fr 1fr' : '1fr' }}
			p={['32px 16px 29px 16px', '22px 80px']}
			justifyContent="center"
			alignItems="center"
			gap={{ base: '24px', xl: '56px' }}
		>
			<Flex flexDirection="column" alignItems={['center', 'center', 'center', 'flex-start']} gap={['12px', '24px']}>
				<Text textStyle={['h3', 'h3', 'h1', 'h1', 'h1', 'h1']}>{data?.title}</Text>
				<Text textStyle={['h6', 'h6', 'h3', 'h3', 'h3', 'h3']} w="70%" textAlign={['center', 'center', 'center', 'left']}>
					{data?.text}
				</Text>
				<Button
					bg="#4358F6"
					variant="primary"
					size="lg"
					color="#FFFFFF"
					as={ReactLink}
					to="/sign-in"
					onClick={() => {
						sendTrackingEvent({
							event: 'cn_start_learnigng2',
							eventLabel: window.location.href,
						});
					}}
				>
					START LEARNING
				</Button>
			</Flex>
			{domainConfig?.uiConfig?.orgBannerImage ? (
				<Box h="full" w="full" borderRadius={'24px'}>
					<Image w="full" maxH="359px" objectFit="cover" h="full" borderRadius={'24px'} src={domainConfig?.uiConfig?.orgBannerImage} />
				</Box>
			) : null}
		</Grid>
	);
};

export default UnlockingOpportunities;
